import axios from "axios";
import api from "../services/axios";

export const FetchPinCodeDetails = async (pinCode) => {
  try
  {
    const res = await api.get(`/Pincode/GetLocationByPincode/${pinCode}`);
    return res?.data;
  }
  catch(error)
  {
    throw error?.response?.data
  }
};